import React from 'react';
import PropTypes from 'prop-types';
import { mergeClasses, Button } from '@fluentui/react-components';
import { Add20Regular } from '@fluentui/react-icons';
import { useAssetsEntryCardStyle } from './style';

const AssetsEntryCard = ({
  id, title, description, imageSrc, onClick, isFillWidth, cardClassName,
}) => {
  const classes = useAssetsEntryCardStyle();

  return (
    <Button
      id={id ? `${id}AssetEntryButton` : undefined}
      onClick={onClick}
      className={mergeClasses('entry-card', classes.assetsEntryCard, isFillWidth && classes.fillWidth, cardClassName)}
    >
      <div className="picture">
        <img src={imageSrc} alt={title} />
      </div>
      <div className="text">
        <div className="title">
          {title}
        </div>
        <div className="description" title={description}>
          {description}
        </div>
      </div>
      <div className="icon">
        <Add20Regular />
      </div>
    </Button>
  );
};
AssetsEntryCard.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  imageSrc: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isFillWidth: PropTypes.bool,
  cardClassName: PropTypes.string,
};

AssetsEntryCard.defaultProps = {
  id: undefined,
  isFillWidth: false,
  cardClassName: '',
};

export const AddAssetEntryCard = AssetsEntryCard;
